import Table from 'react-bootstrap/Table'
import React, { useState, useEffect } from 'react'
import api from '../components/api'
import { useVerificaDesafioContext } from '../context/verificaDesafioContext'
import { useEmailVerContext } from '../context/emailVerContext'

const EmailCorrecoes = (props) => {

    const formulario_id = props.formulario_id
    const origem = props.origem

    const { desafioEmail_id, setDesafioEmail_id } = useEmailVerContext()

    const [resultado, setResultado] = useState([])
    const { verificaDesafio, setVerificaDesafio } = useVerificaDesafioContext()


    const listaEmailsCorrecoes = () => {

        api.get(`emailsCorrecoesDesafio/${formulario_id}`).then((result) => {

            //console.log(result.data)

            setResultado(result.data.map((rs) =>
            
                <tr onClick={() => {setDesafioEmail_id(rs.desafioEmail_id);window.$('#ModalEmailVer').modal('show')}} style={{ cursor: 'pointer' }}>

                    <td style={{ textAlign: 'center'}} >
                        {rs.dataEnvio}
                    </td>
                    <td>
                        {rs.assunto}
                    </td>
                    <td>
                        {rs.usuarioEnvio}
                    </td>

                </tr>
        
            ))

        }).catch((err) => {

            console.log(err.response)

        })

    }


    useEffect(() => {

        listaEmailsCorrecoes()

    }, [formulario_id, verificaDesafio])


    return (

        <div>

            <div className="row">                               



                <div className="col-md-12">


                    <Table striped bordered hover>
                        
                        <thead>
                            <tr>
                                <th><center>Data</center></th>
                                <th>Assunto</th>
                                <th>Enviado por</th>                                
                            </tr>
                        </thead>
                        
                        <tbody>
                           {resultado}
                        </tbody>
                    </Table>

                </div>
                <div className="col-md-12">

                    <div align="right">
                        <button type="button" className="btn btn-info" onClick={() => {window.$('#ModalEmailCorrecao').modal('show')}} >Enviar e-mail</button>
                    </div>

                </div>

            </div>

        </div>

    )
}


export default EmailCorrecoes